import {
  ADMIN_ADD_COURSE_REQUEST,
  ADMIN_ADD_COURSE_SUCCESS,
  ADMIN_ADD_COURSE_FAIL,
  ADMIN_GET_COURSE_REQUEST,
  ADMIN_GET_COURSE_SUCCESS,
  ADMIN_GET_COURSE_FAIL,
  ADMIN_UPDATE_COURSE_REQUEST,
  ADMIN_UPDATE_COURSE_SUCCESS,
  ADMIN_UPDATE_COURSE_FAIL,
  ADMIN_DELETE_COURSE_REQUEST,
  ADMIN_DELETE_COURSE_SUCCESS,
  ADMIN_DELETE_COURSE_FAIL,
  CLEAR_ERRORS
} from "../../constants/admin/courseConstants";

const initialState = {
  courses: [],
  loading: false,
  error: null,
};

export const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_ADD_COURSE_REQUEST:
    case ADMIN_GET_COURSE_REQUEST:
    case ADMIN_UPDATE_COURSE_REQUEST:
    case ADMIN_DELETE_COURSE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADMIN_ADD_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: [...state.courses, action.payload],
      };

    case ADMIN_GET_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: action.payload,
      };

    case ADMIN_UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: state.courses.map((course) =>
          course._id === action.payload._id ? action.payload : course
        ),
      };

    case ADMIN_DELETE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: state.courses.filter(
          (course) => course._id !== action.payload
        ),
      };

    case ADMIN_ADD_COURSE_FAIL:
    case ADMIN_GET_COURSE_FAIL:
    case ADMIN_UPDATE_COURSE_FAIL:
    case ADMIN_DELETE_COURSE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

      case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
